import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { Modal } from 'reactstrap';

const CustomSelect = (props) => {
  const {
    // CustomSelect Props
    customOptions,
    customTitle,
    handleCustomLabel,
    handleCustomValue,
    // Selected Props
    options, onChange, value, styles, ...restProps } = props;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [customOptionValue, setCustomOptionValue] = useState(customOptions ? customOptions[0] : null);
  const [numInputValue, setNumInputValue] = useState('');

  useEffect(() => {
    setCustomOptionValue(customOptions && customOptions[0]);
    setNumInputValue('');
  }, [menuIsOpen])

  const handleOptionSelect = (selectedOption) => {
    if (selectedOption?.label === 'Custom') {
      setModalIsOpen(true);
    } else {
      onChange(selectedOption);
      setMenuIsOpen(false)
    }
  };

  const handlePopupApply = () => {
    const customInputs = { numInputValue: numInputValue, customOptionValue: customOptionValue }

    const customValue = handleCustomValue ? handleCustomValue(customInputs) : "custom";
    const customLabel = handleCustomLabel ? handleCustomLabel(customInputs) : "Custom";
    onChange({ label: customLabel, value: customValue });
    setModalIsOpen(false);
    setMenuIsOpen(false);
  };

  const handleModalClose = () => {
    setModalIsOpen(false);
  };

  const handleMenuClose = () => {
    if(modalIsOpen) return;
    setMenuIsOpen(false);
  };

  const customStyles = {
    control: (styles, { isFocused }) => ({
      ...styles,
      color: "var(--rf-text-primary, #111827)",
      borderRadius: "12px",
      borderColor: isFocused ? 'var(--rf-primary, #4F46E5)' : 'var(--rf-border, #E5E7EB)',
      boxShadow: isFocused ? '0 0 0 1px var(--rf-primary, #4F46E5)' : 'none',
      '&:hover': {
        borderColor: 'var(--rf-primary, #4F46E5)',
      },
    }),
    menu: styles => ({...styles, borderRadius: 16}),
    option: (styles, { isSelected, isFocused }) => ({
      ...styles,
      borderRadius: 6,
      backgroundColor: isSelected ? 'var(--rf-primary, #4F46E5)' : isFocused ? 'var(--rf-primary-light, #EEF2FF)' : 'transparent',
      color: isSelected ? 'white' : 'var(--rf-text-primary, #111827)',
      '&:hover': {
        backgroundColor: 'var(--rf-primary-light, #EEF2FF)',
      },
    }),
  };

  const customHeader = customTitle ? (customTitle) : ("Custom " + props.placeholder + " Value");

  return (
      <>
        <Select options={options} {...restProps}
                styles={{
                  ...styles,
                  clearIndicator: (base) => ({
                    ...base,
                    ...styles.clearIndicator,
                    padding: 0,
                  }),
                }}
                value={value ? value : null}
                onChange={(event) => handleOptionSelect(event)}
                menuIsOpen={menuIsOpen}
                onMenuOpen={() => setMenuIsOpen(true)}
                onMenuClose={handleMenuClose}
                closeMenuOnSelect={false}
        />
        {modalIsOpen && (
            <Modal isOpen={modalIsOpen} toggle={handleModalClose}>
                <div className="rf-filter-custom-modal">
                    <div className="rf-filter-custom-header">
                        <span className="rf-filter-custom-title">{customHeader}</span>
                        <button className="rf-filter-custom-close" onClick={handleModalClose}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{width: 14, height: 14}}>
                                <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </button>
                    </div>
                    <div className="rf-filter-custom-body">
                        {customOptions && (
                            <div className="rf-filter-custom-select-wrap">
                                <Select
                                    options={customOptions}
                                    value={customOptionValue}
                                    onChange={(value) => setCustomOptionValue(value)}
                                    styles={customStyles}
                                />
                            </div>
                        )}
                        <input
                            type="number"
                            className="rf-filter-custom-input"
                            value={numInputValue}
                            onChange={(e) => setNumInputValue(e.target.value)}
                            placeholder="Enter value"
                        />
                    </div>
                    <div className="rf-filter-custom-footer">
                        <button className="rf-filter-custom-cancel" onClick={handleModalClose}>Cancel</button>
                        <button className="rf-filter-custom-apply" onClick={handlePopupApply}>Apply</button>
                    </div>
                </div>
            </Modal>
        )}
      </>
  );
};

export default CustomSelect;